<script setup>
import { useWallSelection } from "@/composables/useWallSelection";
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";

const store = useStore();

const project = computed(() => store.state.projectData);
const model = computed(() => store.state.currentModel);

const { items, selected, loadWalls, autoSelectWallTypes, selectWallsByTypes } = useWallSelection();

const loadingItemsAndSelectedItems = async () => {
  if (model.value && project.value.projectId) {
    const lang = project.value.projectLang || "en";
    await loadWalls(
      project.value.projectId,
      model.value.versions.items[0].referencedObject,
      lang
    );
    selectWallsByTypes(project.value.panelCountEstimator?.selectedWalls ?? []);
  }
};

watch(selected, (newValues) => {
  store.commit("setCustomerSelectedWallType", newValues);
});

function roundToFixed2(number) {
  return (Math.round(number * 100) / 100).toFixed(2);
}

onMounted(() => {
  loadingItemsAndSelectedItems();
});

</script>

<template>
  <h3>{{ $t('functionalities.panelEstimator.modelWallSelection') }}</h3>
  <v-autocomplete v-model="selected" :items="items" bg-color="grey-lighten-2" counter="2" variant="filled" hide-no-data
    hide-details :placeholder="$t('placeholders.wallSelection')" item-title="type" item-value="type" return-object clearable multiple
    chips></v-autocomplete>
  <v-btn class="client-components-button" color="secondary" variant="flat" @click="autoSelectWallTypes">
    {{ $t('functionalities.panelEstimator.automaticSelection') }}
  </v-btn>
  <v-table height="300px">
    <thead>
      <tr>
        <th>{{ $t('type').capitalize() }}</th>
        <th v-html="`${$t('area').capitalize()} (${$t('measuringUnits.inch')}${$t('square')})`"></th>
        <th v-html="`${$t('length').capitalize()} (${$t('measuringUnits.inch')})`"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in selected" :key="item.type">
        <td>{{ item.type }}</td>
        <td>{{ roundToFixed2(Number(item.area)) }}</td>
        <td>{{ roundToFixed2(Number(item.curveLength)) }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<style scoped>
@import '@/assets/styles/components/ClientComponentsSelector.css';
</style>